import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function StockTreePrint(body, name) {
    let bList = [];
    let totalValue = 0;

    body.forEach(element => {
        // Parent Row
        const b = [
            `[${element.data.name.trim()}]`,
            element.data.opening,
            element.data.import,
            element.data.closing,
            element.data.sold,
            element.data.purchase,
            printFormatNumber(element.data.value)
        ];
        
        totalValue += element.data.value === "-" ? 0 : sF(element.data.value);
        bList.push(b);

        if (element.children) {
            element.children.forEach(child => {
                // Child Row
                const c = [
                    `  ${child.data.name}`, // Indent children for better readability
                    child.data.opening,
                    child.data.import,
                    child.data.closing,
                    child.data.sold,
                    child.data.purchase,
                    printFormatNumber(child.data.value)
                ];
                bList.push(c);
            });
        }
    });

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });

    const heading = ['Name', 'Opening', 'Pending', 'Closing', 'Sold', 'Purchased', 'Value'];
    const dateStr = ToBritishDate(new Date());

    // Header Section
    doc.setFontSize(14);
    doc.setTextColor(40);
    doc.text("Stock Report", 40, 40);
    
    doc.setFontSize(10);
    doc.text(name, 40, 55);
    
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Date: ${dateStr}`, 380, 40, { align: 'right' });

    autoTable(doc, {
        head: [heading],
        body: bList,
        foot: [['Total', '', '', '', '', '', printFormatNumber(parseFloat(totalValue.toFixed()))]],
        startY: 75,
        theme: 'striped',
        headStyles: { 
            fontSize: 8, 
            halign: 'center', 
            fillColor: [41, 128, 185], 
            textColor: 255,
            fontStyle: 'bold'
        },
        bodyStyles: { 
            fontSize: 8, 
            textColor: 50 
        },
        footStyles: { 
            fontSize: 8, 
            halign: 'right', 
            fillColor: [241, 241, 241],
            textColor: 0,
            fontStyle: 'bold' 
        },
        alternateRowStyles: { 
            fillColor: [248, 249, 250] 
        },
        columnStyles: {
            0: { halign: "left", cellWidth: 'auto' },
            1: { halign: "right" },
            2: { halign: "right" },
            3: { halign: "right" },
            4: { halign: "right" },
            5: { halign: "right" },
            6: { halign: "right" },
            7: { halign: "right" }
        },
        showFoot: "lastPage",
        margin: { left: 40, right: 40 }
    });

    doc.save(`Stock-${dateStr}.pdf`);
}
